import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserCreationState, UserState } from './user-state-models';

export const userStateFeatureKey = 'userState';

export const selectUserStateFeature = createFeatureSelector<UserState>(userStateFeatureKey);

export const selectUser = createSelector(selectUserStateFeature, (state: UserState) =>
  state ? state.user : null,
);

export const selectUserLoading = createSelector(selectUserStateFeature, (state: UserState) =>
  state ? state.loading : false,
);

export const selectRegistrationFailedErrorType = createSelector(
  selectUserStateFeature,
  (state: UserState) => (state ? state.registrationFailedErrorType : null),
);

export const selectUserIsFetched = createSelector(selectUserStateFeature, (state: UserState) =>
  state ? state.userIsFetched : false,
);

export const selectUserCreationState = createSelector(
  selectUserStateFeature,
  (state: UserState) => state.userCreation,
);

export const selectRegistrationRequest = createSelector(
  selectUserCreationState,
  (state: UserCreationState) => state.registrationRequest,
);

export const selectRegistrationResponse = createSelector(
  selectUserCreationState,
  (state: UserCreationState) => state.registrationResponse,
);
